import { render, staticRenderFns } from "./modalHistorialProductos.vue?vue&type=template&id=67f0a6dc&scoped=true"
import script from "./modalHistorialProductos.vue?vue&type=script&lang=js"
export * from "./modalHistorialProductos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f0a6dc",
  null
  
)

export default component.exports